import getCustomLogger from './logger';


const logger = getCustomLogger('Fetch');

export default class Fetch {
  constructor(url, successCallback, errorCallback) {
    this.url = url;
    this.successCallback = successCallback;
    this.errorCallback = errorCallback;

    this.onError = this.onError.bind(this);
    this.onSuccess = this.onSuccess.bind(this);
  }

  request() {
    logger.log(`Fetching data from URL: ${this.url}`);

    return fetch(this.url).catch(this.onError).then(this.onSuccess);
  }

  /**
   * Call if request returns an error
   *
   * @param {object} error
   * @memberof Fetch
   */
  onError(error) {
    logger.error(`Error while fetching data from URL: ${this.url}`, error);

    this.errorCallback();
    throw error;
  }

  /**
   * Call if request returns an success
   *
   * @param {object} response
   * @memberof Fetch
   */
  async onSuccess(response) {
    logger.debug(`Success while fetching data from URL: ${this.url}`);

    // check if response is the same?
    const data = await response.json();
    this.successCallback(data);
  }
}
